/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var signInIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    width: "19",
    height: "20",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("path", {
      fill: "#FFF",
      fillRule: "nonzero",
      d: "M20 19c0-3.838-2.255-7.339-5.83-8.983l.085-.085a5.768 5.768 0 0 0 0-8.224 5.893 5.893 0 0 0-8.298 0 5.768 5.768 0 0 0 0 8.224A9.834 9.834 0 0 0 0 18.958L2.553 19c0-4.049 3.32-7.339 7.404-7.339 4.086 0 7.405 3.29 7.405 7.339H20zM7.787 3.522a3.322 3.322 0 0 1 4.681-.085 3.251 3.251 0 0 1 .085 4.64l-.085.084a3.444 3.444 0 0 1-4.68 0c-1.32-1.265-1.32-3.332 0-4.64-.043 0-.043 0 0 0z"
    })]
  });
});

export { signInIcon as default };
